import React from 'react';

const DrawerOpenIcon = ({
	size = 13,
	color = 'currentColor',
	className = '',
}: {
	size?: number;
	color?: string;
	className?: string;
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 13 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			d="M8.5 0.5V12.5M11.1667 0.5H1.83333C1.09695 0.5 0.5 1.09695 0.5 1.83333V11.1667C0.5 11.903 1.09695 12.5 1.83333 12.5H11.1667C11.903 12.5 12.5 11.903 12.5 11.1667V1.83333C12.5 1.09695 11.903 0.5 11.1667 0.5Z"
			stroke={color}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default DrawerOpenIcon;
